import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31bc8935"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orders-history-view" }
const _hoisted_2 = {
  key: 0,
  class: "orders"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orders__title" }, "Мои заказы", -1))
const _hoisted_4 = { class: "order__number" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "order__repeat-icon" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Повторить", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "order__date" }
const _hoisted_11 = { class: "order__items" }
const _hoisted_12 = { class: "order__total" }
const _hoisted_13 = { class: "rouble-symbol" }
const _hoisted_14 = { class: "close-icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_EmptyLayout = _resolveComponent("EmptyLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.wasLoaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.orders.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: order.id,
                    class: "orders__item order"
                  }, [
                    _createElementVNode("div", _hoisted_4, "Заказ #" + _toDisplayString(order.id), 1),
                    (order.cheque?.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "order__cheque",
                          href: order.cheque?.url,
                          target: "_blank"
                        }, " Чек ", 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["order__status", {
              'order__status--cancelled': [
                _ctx.ORDER_STATUS.CANCELED,
                _ctx.ORDER_STATUS.FAILED_PAYMENT,
              ].includes(order.status),
            }])
                    }, _toDisplayString(_ctx.ORDER_TITLE_STATUS[order.status]), 3),
                    (!_ctx.isAvailableForPurchase(order.items))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "order__repeat",
                          disabled: _ctx.isProcessing,
                          onClick: _withModifiers(($event: any) => (_ctx.tryRepeatOrder(order.id)), ["stop"])
                        }, _hoisted_9, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$filters.formattedDateTime(order.acceptedAt)), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ProductList, {
                        items: order.items,
                        "window-width": _ctx.windowWidth
                      }, null, 8, ["items", "window-width"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$filters.formattedNumber(order.totalPrice)), 1),
                      (
                order.status == _ctx.ORDER_STATUS.COMPLETED &&
                  (+order.bonusesAccruedSum || +order.bonusesWrittenOffSum)
              )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["bonuses", {
                'bonuses--accrual': +order.bonusesAccruedSum,
                'bonuses--write-off': +order.bonusesWrittenOffSum,
              }])
                          }, _toDisplayString(_ctx.$filters.formattedNumber(+order.bonusesAccruedSum || +order.bonusesWrittenOffSum)) + " ББ ", 3))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                (_ctx.isOpenConfirmWarning)
                  ? (_openBlock(), _createBlock(_component_ModalDialog, { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", {
                            class: "close-icon",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeWarningModal && _ctx.closeWarningModal(...args)))
                          })
                        ]),
                        _createVNode(_component_Warning, {
                          title: _ctx.WARNING_TITLE,
                          text: _ctx.WARNING_TEXT,
                          "is-loading": _ctx.isProcessing,
                          "button-text": "Понятно",
                          onClick: _ctx.repeatOrder
                        }, null, 8, ["title", "text", "is-loading", "onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_EmptyLayout, {
                key: 1,
                title: "Вы не совершали заказов"
              }))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}